import { axios } from '@Root/API'

export const create = data => {
	return axios.post('create/program', data)
}
